export const token = window.$cookies.get('SESSION');